export const DASHBOARD_CONFIG_FIELD_LABELS = {
  device_name: 'Device name',
  device_type: 'Device type',
  area_id: 'Area ID',
  map_x_value: 'Map X position',
  map_y_value: 'Map Y position',
  has_nox: 'Has NOx sensor',
  inactive_device_notification_enabled: 'Inactive device notification',
  device_id: 'Device ID',
  last_update: 'Last update',
  dcv: 'DCV',
  control: 'Control mode',
  on_off: 'Power',
  temp_set_point: 'Temperature set point',
  fan_speed: 'Fan speed',
  mode: 'Mode',
  cool_water_valve: 'Cool water valve',
  slave_id: 'Slave ID',
  comfort: 'Comfort',
  unit_type: 'Unit type',
  device_mac: 'Device MAC',
  controller_model: 'Controller model',
  controller_schedule_patterns_synced: 'Schedule patterns synced',
  active_schedule_id: 'Active schedule',
  cooling_type: 'Cooling type',
  heating_type: 'Heating type',
  keypad_lock: 'Keypad lock',
  area_m2: 'Area size',
  area_cfm: 'Area CFM',
  area_fan_kw: 'Area fan kW',
  space: 'Space type',
  config_version: 'Config version',
  updated_at: 'Updated at',
  channel_1: 'Channel 1',
  channel_2: 'Channel 2',
  channel_3: 'Channel 3',
  channel_4: 'Channel 4',
  default_fan_speed: 'Default fan speed',
  default_mode: 'Default mode',
  default_temp_set_point: 'Default temperature set point',
  default_on_off: 'Default power',
  co2_delta_for_ocp: 'CO2 delta for OCP',
  is_using_radar: 'Using radar',
  source_sensors_ids: 'Source sensors',
};

export const DASHBOARD_CONFIG_VALUE_LABELS = {
  mode: {
    0: 'Fan',
    1: 'Cool',
    2: 'Heat',
    3: 'Auto',
  },
  fan_speed: {
    0: 'Auto',
    1: 'Low',
    2: 'Medium',
    3: 'High',
  },
  on_off: {
    0: 'OFF',
    1: 'ON',
  },
};
